export default __webpack_public_path__ + "static/media/Group 1278@2x.967094b6.png";